import { MapPin, Globe } from "lucide-react";

export const ISSPositionDisplay = ({ latitude, longitude }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
    <div className="bg-white/5 rounded-xl p-6">
      <div className="flex items-center gap-2 mb-4">
        <MapPin className="w-5 h-5 text-cosmic-blue" strokeWidth={1.5} />
        <span className="text-sm text-slate-400 uppercase tracking-wider font-heading">Latitude</span>
      </div>
      <p className="text-4xl font-mono font-bold text-white">
        {latitude?.toFixed(4)}°
      </p>
      <p className="text-sm text-slate-500 mt-1">
        {latitude > 0 ? "North" : "South"}
      </p>
    </div>

    <div className="bg-white/5 rounded-xl p-6">
      <div className="flex items-center gap-2 mb-4">
        <Globe className="w-5 h-5 text-ignition-red" strokeWidth={1.5} />
        <span className="text-sm text-slate-400 uppercase tracking-wider font-heading">Longitude</span>
      </div>
      <p className="text-4xl font-mono font-bold text-white">
        {longitude?.toFixed(4)}°
      </p>
      <p className="text-sm text-slate-500 mt-1">
        {longitude > 0 ? "East" : "West"}
      </p>
    </div>
  </div>
);
